<template>
	<div id="contents" class="contents">
		<Top />
		<StillLife />
		<TsuriGassyuku />
		<div class="section-wrapper">
			<AboutUs />
			<Villa />
			<History />
			<Gallery />
			<Sakana />
		</div>
	</div>
</template>

<script>
import Top from '@/features/home/Top.vue';
import StillLife from '@/features/home/StillLife.vue';
import TsuriGassyuku from '@/features/home/TsuriGassyuku.vue';
import AboutUs from '@/features/home/AboutUs.vue';
import Villa from '@/features/home/Villa.vue';
import History from '@/features/home/History.vue';
import Gallery from '@/features/home/Gallery.vue';
import Sakana from '@/features/home/Sakana.vue';

export default {
	name: 'Home',
	components: {
		Top,
		StillLife,
		TsuriGassyuku,
		AboutUs,
		Villa,
		History,
		Gallery,
		Sakana
	},
};
</script>

<style scoped>
#contents {
	display: flex;
	flex-direction: column;
	min-height: 100vh;
	/* コンテナの高さを100%に設定 */
	gap: 0px;
	/* 各コンポーネントの間隔 */
}

#contents>* {
	flex-shrink: 0;
	/* 各子コンポーネントの高さを固定 */
}

.section-wrapper {
	margin-left: 10%;
	margin-right: 10%;
}
</style>